export default class VistaprintAnalyticsService {
  /**
   * Records a Feature Value Touched event for the given Feature Id
   * @param {number} featureId - the FeatureId (not the feature value) for the feature that should be touched
   */
  static recordFeatureValueTouched(featureId) {
    fetch(`/studio4/touchfeaturevalue?featureId=${featureId}`, {
      method: 'GET',
      credentials: 'include', // send credential cookie with request
    });
  }

  /**
   * Records an event for analytics
   * @param {string} area - the area of the page (e.g. "SubmitButton", "ProductDropdown", or "Header Logo")
   * @param {string} action - the action performed on that area (e.g. "Clicked", "ProductChanged", or "Hovered")
   * @param {string} details - (optional) additional info that might be important (e.g. for ProductDropdown:ProductChanged, you might supply PFID for details)
   */
  static recordEvent(area, action, details = undefined) {
    const eventName = `${area}${action}`;

    try {
      window.$('body').trigger('onAnalyticsTagEvent',
        {
          EventType: 'custom link',
          EventName: eventName,
          CustomEventData: {
            PageSection: 'Design Services',
            PageInteractionArea: area,
            PageInteractionTool: '',
            PageInteractionAction: action,
            PageInteractionDetails: details,
          },
        });
    } catch (ex) {
      try {
        const { vp } = window;

        if (vp && vp.instrumentation && vp.instrumentation.logException) {
          vp.instrumentation.logException(ex);
        }
      } catch (ex2) {
        console.error(ex2);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/VistaprintAnalyticsService.js